const offlineCourseBeneficiarToggle = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const beneficiarCheckbox = document.querySelector('input[name="beneficiar[]"]');
    const beneficiarSite     = document.querySelector('.beneficiar-site');
    const beneficiarCat      = document.querySelector('.beneficiar-cat');
    const submitBtn          = document.querySelector('#offline_course_submit');
    const popupClose = document.getElementById('popup-close');

    if (!beneficiarCheckbox || !beneficiarSite || !beneficiarCat || !submitBtn) return;

    const toggle = () => {
      const isChecked = beneficiarCheckbox.checked;

      beneficiarSite.style.display = isChecked ? 'block' : 'none';
      beneficiarCat.style.display  = isChecked ? 'block' : 'none';
      submitBtn.style.display      = isChecked ? 'none'  : '';
    };

    toggle();

    beneficiarCheckbox.addEventListener('change', toggle);

    if (popupClose) {
      popupClose.addEventListener('click', () => {
        beneficiarSite.style.display = 'none';
        beneficiarCat.style.display  = 'none';
        submitBtn.style.display      = '';
      });
    }
  });
};

export default offlineCourseBeneficiarToggle;
